// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app/components/static/AuditTool/AuditShare.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app/components/static/AuditTool/AuditShare.tsx");
  import.meta.hot.lastModified = "1726768115963.7239";
}
// REMIX HMR END

import IconResolver from "~/components/IconResolver";
import Link from "~/components/Link";
const socialMediaLinks = [{
  token: "twitter",
  href: "https://twitter.com/intent/tweet/?text=REPLACE_TEXT&url=REPLACE_URL"
}, {
  token: "linkedin",
  href: "https://www.linkedin.com/sharing/share-offsite/?text=REPLACE_TEXT&url=REPLACE_URL"
}, {
  token: "facebook",
  href: "https://facebook.com/sharer/sharer.php?u=REPLACE_URL"
}];
const shareText = {
  performance: `My website successfuly pased Doc. Tahedroid’s performance test!

Want to see how yours measures up? Let Doc. Tahedroid assess the health of your website or meta tags at:
`,
  opengraph: `My website successfully passed Doc. Tahedroid’s meta tags test!

Want to see how yours measures up? Let Doc. Tahedroid assess the health of your website or meta tags at:
`
};
export default function AuditShare({
  reportId,
  reportKind
}) {
  const URL = `https://octahedroid.com/audit?reportId=${reportId}`;
  return <section className="flex justify-start items-center my-4 gap-6 w-full">
      {socialMediaLinks.map(link => {
      const to = link.href.replace("REPLACE_URL", encodeURIComponent(URL)).replace("REPLACE_TEXT", encodeURIComponent(shareText[reportKind]));
      return <Link key={link.token} to={to} className="flex items-center justify-center w-[18px] aspect-square !text-neutral-500 !mr-0" target="_blank" rel="noopener" aria-label={`Share on ${link.token}`}>
            <IconResolver token={link.token} />
          </Link>;
    })}
      <button type="button" onClick={() => navigator.clipboard.writeText(URL)}>
        <IconResolver token="duplicate" className="flex items-center justify-center w-8 aspect-square !text-neutral-500" />
      </button>
    </section>;
}
_c = AuditShare;
var _c;
$RefreshReg$(_c, "AuditShare");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;